import React from 'react';
import useReveal from '../../AIEmployees/useReveal';
import WallFrame from '../../AIEmployees/sections/WallFrame';

/**
 * SADrive — the Drive feature on /super-agents.
 *
 * Since Sep 1 2026 (Nitish's ruling) this section renders the SAME Drive
 * frame as the /ai-employees wall via WallFrame (picked by its frame class), instead of its
 * own older copy: one source, so every wall fix (mobile icon rail, tile
 * flow, timings) lands on both pages at once. Section head + caption stay
 * this page's own copy. The old bespoke frame + SADrive.css are retired.
 */
const SADrive = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-drive aie-section">
      <div className="aie-section-head">
        <span className="aie-eyebrow">Drive</span>
        <h2 className="aie-section-title aie-display">The work lands as real files.</h2>
        <p className="aie-section-sub">
          Ask in chat and the finished artifact files itself in your Drive. Next to it
          sits the Organization Drive: one set of folders the whole team, humans and
          AI employees, works from.
        </p>
      </div>
      <div className={`sa-drive__reveal aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        <WallFrame cls="wm-drv" />
      </div>
      <p className="aie-caption">
        <strong>Your Drive holds your work. The Organization Drive holds the team&rsquo;s.</strong>{' '}
        Files land there from chat, from uploads, and from your AI employees, all in the same folders.
      </p>
    </section>
  );
};

export default SADrive;
